// IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах)
// ОБЩИЙ ИСТОЧНИК вида отметки «Plan start» (начало плана): одна «капсула» — белый фон, штрихи внутри, рамка 1 px приглушённого --plan-start-color,
// скругление 4 px, внутренний отступ 2 px, флажок сверху внутри. Три способа рисования, одни числа:
//   HTML (таблица AttrGrid, гант движений AttrGanttMoves): классы .ps-capsule / .ps-head / .ps-body / .ps-flag — CSS в App.vue (рядом с токеном);
//   SVG (график AttrChart, мини-ганты Dropdown / AttrAnalysis): planStartSvg() ниже — та же геометрия и тот же рисунок штриховки;
//   фаза штрихов при вертикальной прокрутке (полоса тела едет, шапка стоит): planStartPhase().
// Выключатель fe.ux.planStartMark проверяют вызывающие (как раньше).
export const PS = {
    W: 15,                         // ширина капсулы = разрыв таблицы (break_width)
    FRAME: 1,                      // рамка, px
    RADIUS: 4,                     // скругление, px
    PAD: 2,                        // внутренний отступ до штрихов, px
    HEAD: 17,                      // зона флажка сверху (без штрихов), px
    STEP: 7,                       // шаг штрихов вдоль нормали, px
    INK: 2,                        // толщина штриха, px
    PERIOD: 7 * Math.SQRT2,        // период штрихов по вертикали при 45°
}

// цвет штрихов и флажка — токен --plan-start-color (App.vue; IE 2026 10 02 / ODOO-343343 (заказ Игоря: фон белый, штриховка и флаг — цветом бордюра): цвет разделителей шапки таблицы --cs-header-border, classic — #A3B6BE); запас — фиолетовый линии дня факта
export function planStartColor() {
    let c = ''
    try { c = getComputedStyle(document.body).getPropertyValue('--plan-start-color').trim() } catch (e) { /* без стилей */ }
    return c || '#7b1fa2'
}
// IE 2026 09 30 / ODOO-343343 (заказ Игоря: цвет разделителя — как рамки и текст шапки): цвет рамки — токен --plan-start-frame с body (разделители шапки таблицы, App.vue); запас — цвет штрихов
export function planStartFrame(color) {
    let c = ''
    try { c = getComputedStyle(document.body).getPropertyValue('--plan-start-frame').trim() } catch (e) { /* без стилей */ }
    return c || color || planStartColor()
}

// IE 2026 10 02 / ODOO-343343 (заказ Игоря: фон белый, штриховка и флаг — цветом бордюра): цвет подложки капсулы — токен --plan-start-ground с body (App.vue: белый во всех гаммах, единая точка переключения); запас — белый
export function planStartGround() {
    let c = ''
    try { c = getComputedStyle(document.body).getPropertyValue('--plan-start-ground').trim() } catch (e) { /* без стилей */ }
    return c || '#fff'
}

// фаза штрихов: k — верх рисунка в координатах полосы (px, от её верха); приводится к (-PERIOD, 0] сдвигом на кратное периоду; h — высота полосы.
// Возвращает { pos, size }: background-position-y и высота рисунка (рисунок покрывает всю полосу без повторов и швов)
export function planStartPhase(k, h) {
    let pos = +k || 0
    if (pos > 0) pos -= PS.PERIOD * Math.ceil(pos / PS.PERIOD)
    return { pos, size: (+h || 0) - pos + 2 }
}

const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
let _uid = 0

// SVG-капсула (под сериями / барами): { x — левый край, y — верх, h — высота, color, head — зона флажка сверху (по умолчанию да), id — суффикс id паттерна }.
// Рамка + белая подложка + штрихи; флажок рисуют planStartHeadSvg (глухая «шапка» поверх серий — график) либо planStartFlagSvg (только знак — мини-ганты).
export function planStartSvg({ x, y, h, color, head = true, id = '' } = {}) {
    color = color || planStartColor()
    const { W, FRAME, RADIUS, PAD, HEAD, STEP, INK } = PS
    const pid = 'ps-hatch-' + (String(id).replace(/[^A-Za-z0-9_-]/g, '_') || ('u' + (++_uid)))
    const ix = x + FRAME + PAD, iw = W - 2 * (FRAME + PAD), iy = y + FRAME + (head ? HEAD : PAD), ih = Math.max(0, h - FRAME - (head ? HEAD : PAD) - FRAME - PAD)
    let s = `<g class="ps-svg" pointer-events="none">`
    s += `<defs><pattern id="${pid}" patternUnits="userSpaceOnUse" width="${STEP}" height="${STEP}" patternTransform="rotate(45)"><line x1="${STEP - INK / 2}" y1="0" x2="${STEP - INK / 2}" y2="${STEP}" stroke="${esc(color)}" stroke-width="${INK}"/></pattern></defs>`
    s += `<rect class="ps-svg-frame" x="${x + FRAME / 2}" y="${y + FRAME / 2}" width="${W - FRAME}" height="${Math.max(0, h - FRAME)}" rx="${RADIUS}" ry="${RADIUS}" fill="${esc(planStartGround())}" stroke="${esc(planStartFrame(color))}" stroke-width="${FRAME}"/>`
    if (ih > 0) s += `<rect class="ps-svg-hatch" x="${ix}" y="${iy}" width="${iw}" height="${ih}" fill="url(#${pid})"/>`
    return s + `</g>`
}
const GLYPH = '\ue9de'   // pi-flag-fill
// знак флажка; hit — прозрачная зона шапки ловит мышь (нативный title = tip)
export function planStartFlagSvg({ x, y, color, tip = '', hit = false } = {}) {
    color = color || planStartColor()
    let s = `<g class="ps-svg-flagg">`
    s += `<text class="ps-svg-flag" x="${x + PS.W / 2}" y="${y + 13}" text-anchor="middle" font-size="12" fill="${esc(color)}" font-family="primeicons" pointer-events="none">${GLYPH}</text>`
    if (hit) s += `<rect x="${x}" y="${y}" width="${PS.W}" height="${PS.HEAD}" fill="#fff" fill-opacity="0" pointer-events="all"><title>${esc(tip)}</title></rect>`
    return s + `</g>`
}
// глухая шапка капсулы (белая, рамка сверху и по бокам, скругление сверху) + флажок — поверх серий графика (шапка закрывает серии под флажком, как раньше плашка)
export function planStartHeadSvg({ x, y, color } = {}) {
    color = color || planStartColor()
    const { W, FRAME, RADIUS: R, HEAD } = PS
    const x0 = x + FRAME / 2, x1 = x + W - FRAME / 2, y0 = y + FRAME / 2, yb = y + FRAME + HEAD
    const open = `M${x0} ${yb}V${y0 + R}A${R} ${R} 0 0 1 ${x0 + R} ${y0}H${x1 - R}A${R} ${R} 0 0 1 ${x1} ${y0 + R}V${yb}`
    return `<path class="ps-svg-headfill" d="${open}Z" fill="${esc(planStartGround())}" stroke="none" pointer-events="none"/>` +
        `<path class="ps-svg-headline" d="${open}" fill="none" stroke="${esc(planStartFrame(color))}" stroke-width="${FRAME}" pointer-events="none"/>` +
        planStartFlagSvg({ x, y, color })
}
